module.exports = __webpack_public_path__ + "index-banner-m.jpg?dc4752bba2d5f4b052b9a8903892dc49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner-m.jpg
// module id = 87
// module chunks = 0